/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Trainer_LongInputs */

const en_for_whom_trainer_long = /** @type {(inputs: For_Whom_Trainer_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write a plan for weeks from your exercise library and send it in one click. Your client trains with it on their phone, and you see every set they log.`)
};

const pl_for_whom_trainer_long = /** @type {(inputs: For_Whom_Trainer_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piszesz plan na tygodnie z biblioteki ćwiczeń i wysyłasz go jednym kliknięciem. Podopieczny trenuje z nim w telefonie, a Ty widzisz każdą zaliczoną serię.`)
};

/**
* | output |
* | --- |
* | "Write a plan for weeks from your exercise library and send it in one click. Your client trains with it on their phone, and you see every set they log." |
*
* @param {For_Whom_Trainer_LongInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_trainer_long = /** @type {((inputs?: For_Whom_Trainer_LongInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Trainer_LongInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_trainer_long(inputs)
	return en_for_whom_trainer_long(inputs)
});